import type { Policy } from '../../../../../common/js/customer/Policy';
import { AccountCenterControllerInterface } from '../../../interfaces/account-center/AccountCenterControllerInterface';
import { Component } from '@angular/core';
import { AccountCenterService } from '../../../services/account-center/account-center.service';
import { AmorphicService } from '../../../services/amorphic/amorphic.service';
import { CommonUtils } from '../../../../../common/js/static/CommonUtils';

@Component({
  selector: 'correction-partial',
  moduleId: module.id,
  templateUrl: './correction-partial.component.html',
})
export class CorrectionPartialComponent {
  controller;
  policy: Policy;
  accountCenterController: AccountCenterControllerInterface;
  customer;
  showInsured: boolean = false;
  showOwner: boolean = false;
  personType: string;
  requirement: string;
  futureSubState: string;
  isOwnerSameAsInsured: boolean;

  constructor(private amorphicService: AmorphicService, private accountCenterService: AccountCenterService) {
    this.controller = amorphicService.controller;
    this.accountCenterController = this.controller.accountCenterController;
    this.customer = this.controller.customer;
  }

  ngOnInit(): void {
    this.policy = this.customer.application.primaryPolicy;
    this.isOwnerSameAsInsured = this.policy.isOwnerSameAsInsured();

    this.accountCenterService.workflowStateSubject.subscribe((workflowState) => {
      this.setCorrectionType(workflowState);
    });
    this.displayForm(this.personType);
  }

  setCorrectionType(workflowStage: string): void {
    switch (workflowStage) {
      case 'TLIC Application:Correcting SSN':
        this.personType = 'insured';
        this.requirement = 'Fix ID';
        this.futureSubState = '';
        break;
      case 'TLIC Application:Correcting Insured SSN':
        this.personType = 'insured';
        this.requirement = 'Fix Insured ID';
        if (this.isOwnerSameAsInsured) {
          this.futureSubState = '';
        } else {
          this.futureSubState = 'Correcting Owner SSN';
        }
        break;
      case 'TLIC Application:Correcting Owner SSN':
        this.personType = 'owner';
        this.requirement = 'Fix Owner ID';
        this.futureSubState = '';
        break;
      case 'TLIC Application:Correcting License':
        this.personType = 'insured';
        this.requirement = 'Fix MVR';
        this.futureSubState = '';
        break;
    }
  }

  displayForm(personType: string): void {
    if (personType === 'insured') {
      this.showInsured = true;
      this.showOwner = false;
    } else if (personType === 'owner') {
      this.showInsured = false;
      this.showOwner = true;
    }
  }

  private copyPersonToOwner(): void {
    this.policy.ownerPerson.firstName = this.policy.insured.person.firstName;
    this.policy.ownerPerson.middleName = this.policy.insured.person.middleName;
    this.policy.ownerPerson.lastName = this.policy.insured.person.lastName;
    this.policy.ownerPerson.SSN = this.policy.insured.person.SSN;
    this.policy.ownerPerson.dob = this.policy.insured.person.dob;
    this.policy.ownerPerson.age = this.policy.insured.person.age;
    this.policy.ownerPerson.residentialAddress.street = this.policy.insured.person.residentialAddress.street;
    this.policy.ownerPerson.residentialAddress.line1 = this.policy.insured.person.residentialAddress.line1;
    this.policy.ownerPerson.residentialAddress.zip = this.policy.insured.person.residentialAddress.zip;
    this.policy.ownerPerson.residentialAddress.city = this.policy.insured.person.residentialAddress.city;
    this.policy.ownerPerson.residentialAddress.state = this.policy.insured.person.residentialAddress.state;
  }

  public async submitCorrection(): Promise<void> {
    if (this.isOwnerSameAsInsured) {
      this.copyPersonToOwner();
    }
    this.accountCenterController.checkRequirement(this.policy, this.requirement, this.futureSubState);
  }
}
